// src/screens/DetailScreens.jsx
import React, { useState } from "react";
import { Stars, Btn, ScrollArea, GradientHero, Screen } from "../components/UI";
import { TICKET_TIERS, CITIES } from "../data/events";

// ── Event Detail ───────────────────────────────────────────────────────────
export function EventDetail({ ev, saved, onSave, comments, onAddComment, onLike, onBack, onTickets }) {
  const [newComment, setNewComment] = useState("");
  const [userStars,  setUserStars]  = useState(0);

  const avg     = comments.length ? (comments.reduce((s,c)=>s+c.stars,0)/comments.length).toFixed(1) : null;
  const dist    = [5,4,3,2,1].map(s => comments.filter(c=>c.stars===s).length);
  const hasTix  = !!TICKET_TIERS[ev.id];

  const submit = () => {
    if (!newComment.trim()) return;
    onAddComment(ev.id, { id:Date.now(), user:"Amara K", av:"AK", bg:"#AFA9EC", tc:"#26215C", stars:userStars||5, text:newComment, time:"Just now", likes:0, liked:false });
    setNewComment(""); setUserStars(0);
  };

  return (
    <Screen>
      <GradientHero grad={ev.grad} height={200}>
        <button onClick={onBack} style={{ position:"absolute", top:12, left:12, background:"rgba(255,255,255,0.18)", border:"none", color:"#fff", borderRadius:20, padding:"5px 11px", fontSize:11, cursor:"pointer" }}>← Back</button>
        <button onClick={()=>onSave(ev.id)} style={{ position:"absolute", top:12, right:12, background:saved?"rgba(255,255,255,0.38)":"rgba(255,255,255,0.18)", border:"none", color:"#fff", borderRadius:20, padding:"5px 11px", fontSize:11, cursor:"pointer" }}>{saved?"✓ Saved":"Save"}</button>
        <div>
          <div style={{ fontSize:18, fontWeight:500, color:"#fff", marginBottom:3 }}>{ev.title}</div>
          <div style={{ fontSize:11, color:"rgba(255,255,255,0.85)" }}>{ev.date} · {ev.venue} · {ev.priceLabel}</div>
        </div>
      </GradientHero>

      <ScrollArea style={{ padding:"13px 16px" }}>
        {/* Info rows */}
        {[{ label:"Date & time", value:`${ev.date} · ${ev.time}` },{ label:"Venue", value:`${ev.venue} · ${ev.crowd} capacity` },{ label:"Price", value:ev.priceLabel }].map(r=>(
          <div key={r.label} style={{ display:"flex", gap:8, alignItems:"center", marginBottom:8 }}>
            <div style={{ width:28, height:28, borderRadius:7, background:"#f5f5f5", display:"flex", alignItems:"center", justifyContent:"center", flexShrink:0, fontSize:14 }}>
              {r.label==="Date & time"?"📅":r.label==="Venue"?"📍":"🎟️"}
            </div>
            <div>
              <div style={{ fontSize:10, color:"#999" }}>{r.label}</div>
              <div style={{ fontSize:12, color:"#111" }}>{r.value}</div>
            </div>
          </div>
        ))}

        {/* Highlights */}
        <div style={{ marginTop:10, marginBottom:12 }}>
          <div style={{ fontSize:11, fontWeight:500, color:"#999", textTransform:"uppercase", letterSpacing:"0.5px", marginBottom:6 }}>Highlights</div>
          <div style={{ display:"flex", gap:5, flexWrap:"wrap" }}>
            {ev.highlights.map(h=><span key={h} style={{ fontSize:11, padding:"3px 10px", borderRadius:20, background:"#f5f5f5", color:"#555" }}>{h}</span>)}
          </div>
        </div>

        {/* Vibes */}
        <div style={{ marginBottom:12 }}>
          <div style={{ fontSize:11, fontWeight:500, color:"#999", textTransform:"uppercase", letterSpacing:"0.5px", marginBottom:6 }}>Vibe</div>
          <div style={{ display:"flex", gap:5, flexWrap:"wrap" }}>
            {ev.vibes.map(v=><span key={v} style={{ fontSize:11, padding:"3px 10px", borderRadius:20, background:"#EEEDFE", color:"#534AB7" }}>{v}</span>)}
          </div>
        </div>

        {/* Lineup */}
        {ev.lineup.length > 0 && (
          <div style={{ marginBottom:12 }}>
            <div style={{ fontSize:11, fontWeight:500, color:"#999", textTransform:"uppercase", letterSpacing:"0.5px", marginBottom:6 }}>Lineup</div>
            <div style={{ display:"flex", gap:9, overflowX:"auto", paddingBottom:4 }}>
              {ev.lineup.map(a=>(
                <div key={a.name} style={{ flexShrink:0, textAlign:"center" }}>
                  <div style={{ width:46, height:46, borderRadius:"50%", background:"#EEEDFE", color:"#534AB7", display:"flex", alignItems:"center", justifyContent:"center", fontSize:16, fontWeight:500, margin:"0 auto 4px" }}>{a.name.charAt(0)}</div>
                  <div style={{ fontSize:10, fontWeight:500, color:"#111", width:58, overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap" }}>{a.name}</div>
                  <div style={{ fontSize:9, color:"#999" }}>{a.time}</div>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* Ratings */}
        <div style={{ marginBottom:12 }}>
          <div style={{ fontSize:11, fontWeight:500, color:"#999", textTransform:"uppercase", letterSpacing:"0.5px", marginBottom:7 }}>Ratings & reviews</div>
          {avg ? (
            <div style={{ display:"flex", gap:13, alignItems:"center", marginBottom:10 }}>
              <div style={{ textAlign:"center" }}>
                <div style={{ fontSize:26, fontWeight:500, color:"#111" }}>{avg}</div>
                <Stars value={parseFloat(avg)} size={11}/>
                <div style={{ fontSize:9, color:"#999", marginTop:1 }}>{comments.length} reviews</div>
              </div>
              <div style={{ flex:1 }}>
                {dist.map((n,i)=>(
                  <div key={i} style={{ display:"flex", alignItems:"center", gap:5, marginBottom:3 }}>
                    <span style={{ fontSize:9, color:"#999", width:8 }}>{5-i}</span>
                    <div style={{ flex:1, height:4, background:"#f0f0f0", borderRadius:2, overflow:"hidden" }}>
                      <div style={{ width:`${comments.length?Math.round(n/comments.length*100):0}%`, height:"100%", background:"#EF9F27", borderRadius:2 }}/>
                    </div>
                    <span style={{ fontSize:9, color:"#999", width:16, textAlign:"right" }}>{n}</span>
                  </div>
                ))}
              </div>
            </div>
          ) : <div style={{ fontSize:12, color:"#999", marginBottom:8 }}>No reviews yet — be the first!</div>}
        </div>

        {/* Comments */}
        <div style={{ marginBottom:13 }}>
          <div style={{ fontSize:11, fontWeight:500, color:"#999", textTransform:"uppercase", letterSpacing:"0.5px", marginBottom:7 }}>Comments ({comments.length})</div>
          {comments.length > 0 && (
            <div style={{ background:"#fff", borderRadius:12, border:"0.5px solid rgba(0,0,0,0.08)", marginBottom:9 }}>
              {comments.map((c,i)=>(
                <div key={c.id} style={{ padding:"9px 11px", borderBottom:i<comments.length-1?"0.5px solid rgba(0,0,0,0.06)":"none" }}>
                  <div style={{ display:"flex", alignItems:"center", gap:7, marginBottom:4 }}>
                    <div style={{ width:24, height:24, borderRadius:"50%", background:c.bg, color:c.tc, display:"flex", alignItems:"center", justifyContent:"center", fontSize:9, fontWeight:500 }}>{c.av}</div>
                    <div style={{ fontSize:11, fontWeight:500, color:"#111" }}>{c.user}</div>
                    <Stars value={c.stars} size={10}/>
                    <div style={{ fontSize:9, color:"#999", marginLeft:"auto" }}>{c.time}</div>
                  </div>
                  <div style={{ fontSize:11, color:"#555", lineHeight:1.5 }}>{c.text}</div>
                  <button onClick={()=>onLike(ev.id,c.id)} style={{ marginTop:5, fontSize:10, background:"none", border:"none", cursor:"pointer", color:c.liked?"#D4537E":"#999" }}>
                    ♥ {c.likes}
                  </button>
                </div>
              ))}
            </div>
          )}
          {/* Add comment */}
          <div style={{ fontSize:11, color:"#666", marginBottom:4 }}>Your rating:</div>
          <Stars value={userStars} size={20} interactive onChange={setUserStars}/>
          <div style={{ display:"flex", gap:7, alignItems:"center", marginTop:8 }}>
            <input value={newComment} onChange={e=>setNewComment(e.target.value)} onKeyDown={e=>{if(e.key==="Enter")submit();}} placeholder="Add a comment..." style={{ flex:1, background:"#f5f5f5", border:"0.5px solid rgba(0,0,0,0.1)", borderRadius:20, padding:"8px 12px", fontSize:12, color:"#111", outline:"none" }}/>
            <button onClick={submit} style={{ background:"#7F77DD", color:"#fff", border:"none", borderRadius:"50%", width:30, height:30, cursor:"pointer", fontSize:16, display:"flex", alignItems:"center", justifyContent:"center" }}>→</button>
          </div>
        </div>
        <div style={{ height:10 }}/>
      </ScrollArea>

      {/* CTA */}
      <div style={{ padding:"0 16px 14px", display:"flex", gap:8, flexShrink:0, background:"#fff", borderTop:"0.5px solid rgba(0,0,0,0.07)" }}>
        {hasTix
          ? <Btn variant="primary" onClick={()=>onTickets(ev)} style={{ flex:1 }}>Get tickets</Btn>
          : <Btn variant="primary" style={{ flex:1 }}>Going</Btn>
        }
        <Btn variant="outline" onClick={()=>onSave(ev.id)} style={{ padding:"9px 14px" }}>{saved?"Saved ✓":"Save"}</Btn>
      </div>
    </Screen>
  );
}

// ── Tickets ────────────────────────────────────────────────────────────────
export function TicketScreen({ ev, onBack, onConfirm }) {
  const tiers   = TICKET_TIERS[ev.id] || [];
  const [sel, setSel]   = useState(null);
  const [qty, setQty]   = useState(1);
  const tier  = tiers[sel];
  const subtotal = tier ? tier.price * qty : 0;
  const fee      = tier ? Math.round(subtotal * 0.08) : 0;
  const total    = subtotal + fee;

  return (
    <Screen>
      <GradientHero grad={ev.grad} height={130}>
        <button onClick={onBack} style={{ position:"absolute", top:11, left:11, background:"rgba(255,255,255,0.18)", border:"none", color:"#fff", borderRadius:20, padding:"5px 11px", fontSize:11, cursor:"pointer" }}>← Back</button>
      </GradientHero>
      <ScrollArea style={{ padding:"13px 16px" }}>
        <div style={{ fontSize:16, fontWeight:500, color:"#111", marginBottom:2 }}>{ev.title}</div>
        <div style={{ fontSize:12, color:"#666", marginBottom:13 }}>{ev.date} · {ev.venue}</div>

        {tiers.map((t,i)=>(
          <div key={i} onClick={()=>setSel(i)} style={{ background:sel===i?"#EEEDFE":"#f5f5f5", borderRadius:13, padding:"11px 12px", marginBottom:8, cursor:"pointer", border:`1.5px solid ${sel===i?"#7F77DD":"transparent"}` }}>
            <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center" }}>
              <div style={{ fontSize:13, fontWeight:500, color:"#111" }}>{t.name}</div>
              <div style={{ fontSize:13, fontWeight:500, color:"#7F77DD" }}>R{t.price}</div>
            </div>
            <div style={{ fontSize:11, color:"#666", marginTop:2 }}>{t.desc}</div>
            {sel === i && (
              <div style={{ display:"flex", alignItems:"center", gap:10, marginTop:8 }}>
                <button onClick={e=>{e.stopPropagation();setQty(q=>Math.max(1,q-1));}} style={{ width:26, height:26, borderRadius:"50%", border:"0.5px solid rgba(0,0,0,0.18)", background:"#fff", cursor:"pointer", fontSize:16 }}>−</button>
                <span style={{ fontSize:14, fontWeight:500, color:"#111", minWidth:20, textAlign:"center" }}>{qty}</span>
                <button onClick={e=>{e.stopPropagation();setQty(q=>q+1);}} style={{ width:26, height:26, borderRadius:"50%", border:"0.5px solid rgba(0,0,0,0.18)", background:"#fff", cursor:"pointer", fontSize:16 }}>+</button>
              </div>
            )}
          </div>
        ))}

        {tier && (
          <div style={{ background:"#f5f5f5", borderRadius:13, padding:"11px 12px", marginTop:8 }}>
            <div style={{ fontSize:12, fontWeight:500, color:"#111", marginBottom:7 }}>Order summary</div>
            <div style={{ display:"flex", justifyContent:"space-between", fontSize:12, color:"#666", marginBottom:3 }}><span>{qty}× {tier.name}</span><span>R{subtotal}</span></div>
            <div style={{ display:"flex", justifyContent:"space-between", fontSize:12, color:"#666", marginBottom:3 }}><span>iPulse fee (8%)</span><span>R{fee}</span></div>
            <div style={{ display:"flex", justifyContent:"space-between", fontSize:13, fontWeight:500, color:"#111", paddingTop:7, borderTop:"0.5px solid rgba(0,0,0,0.08)", marginTop:5 }}><span>Total</span><span>R{total}</span></div>
          </div>
        )}
        <div style={{ height:10 }}/>
      </ScrollArea>

      <div style={{ padding:"0 16px 14px", flexShrink:0 }}>
        <button onClick={()=>{if(tier)onConfirm(ev,tier,qty,total);}} disabled={!tier} style={{ width:"100%", background:tier?"#7F77DD":"#ddd", color:tier?"#fff":"#999", border:"none", borderRadius:20, padding:12, fontSize:14, fontWeight:500, cursor:tier?"pointer":"default" }}>
          {tier ? `Pay R${total} securely` : "Select a ticket type"}
        </button>
        <div style={{ textAlign:"center", fontSize:10, color:"#999", marginTop:6 }}>Secured by iPulse Pay · Instant e-ticket delivery</div>
      </div>
    </Screen>
  );
}

// ── Confirmation ───────────────────────────────────────────────────────────
export function ConfirmScreen({ ev, tier, qty, total, onDone }) {
  const qrBits = Array.from({ length:16 }, () => Math.random() > 0.35);
  return (
    <div style={{ display:"flex", flexDirection:"column", alignItems:"center", justifyContent:"center", padding:"40px 22px", minHeight:500, textAlign:"center", flex:1, overflowY:"auto" }}>
      <div style={{ width:64, height:64, borderRadius:"50%", background:"#EAF3DE", display:"flex", alignItems:"center", justifyContent:"center", margin:"0 auto 14px", fontSize:28 }}>✓</div>
      <div style={{ fontSize:19, fontWeight:500, color:"#111", marginBottom:7 }}>You're going!</div>
      <div style={{ fontSize:13, color:"#666", marginBottom:22, lineHeight:1.6 }}>
        Your tickets for <strong>{ev.title}</strong> are confirmed.<br/>E-ticket sent to your email.
      </div>
      <div style={{ background:"#f5f5f5", borderRadius:14, padding:16, width:"100%", marginBottom:18, border:"0.5px solid rgba(0,0,0,0.1)" }}>
        <div style={{ fontSize:14, fontWeight:500, color:"#111", marginBottom:3 }}>{ev.title}</div>
        <div style={{ fontSize:11, color:"#666", marginBottom:11 }}>{ev.date} · {qty}× {tier.name} · R{total}</div>
        <div style={{ width:72, height:72, background:"#fff", borderRadius:9, margin:"0 auto", display:"grid", gridTemplateColumns:"repeat(4,1fr)", gap:2, padding:5 }}>
          {qrBits.map((on,i)=><div key={i} style={{ borderRadius:1, background:on?"#111":"transparent" }}/>)}
        </div>
      </div>
      <button onClick={onDone} style={{ width:"100%", background:"#7F77DD", color:"#fff", border:"none", borderRadius:20, padding:12, fontSize:14, fontWeight:500, cursor:"pointer", marginBottom:8 }}>Back to iPulse</button>
    </div>
  );
}

// ── Onboarding ─────────────────────────────────────────────────────────────
export function OnboardingScreen({ onDone }) {
  const [name,  setName]  = useState("");
  const [city,  setCity]  = useState("Cape Town");
  const [vibe,  setVibe]  = useState(null);
  const VIBES = [
    {id:"introvert",emoji:"🎧",label:"Introvert",desc:"Calm spots, small crowds, cultural events"},
    {id:"extrovert",emoji:"🎉",label:"Extrovert",desc:"Parties, nightlife, big festivals"},
    {id:"tourist",  emoji:"🧳",label:"Tourist",  desc:"Landmarks, local culture, must-sees"},
    {id:"explorer", emoji:"🔍",label:"Explorer", desc:"Hidden gems, off-beat events"},
  ];
  return (
    <div style={{ display:"flex", flexDirection:"column", flex:1, overflowY:"auto", padding:"24px 20px 28px", background:"#fff" }}>
      <div style={{ textAlign:"center", marginBottom:20 }}>
        <div style={{ fontSize:30, fontWeight:500, letterSpacing:"-0.5px", marginBottom:4 }}>
          <span style={{ color:"#D4537E", fontStyle:"italic" }}>i</span><span style={{ color:"#111" }}>Pulse</span>
        </div>
        <div style={{ fontSize:12, color:"#999" }}>Your city. Your vibe.</div>
      </div>

      <div style={{ fontSize:15, fontWeight:500, color:"#111", marginBottom:3 }}>Welcome! Let's set you up.</div>
      <div style={{ fontSize:12, color:"#666", marginBottom:14 }}>Just a few details and you're ready to go.</div>

      <label style={{ fontSize:11, color:"#666", marginBottom:4 }}>Your name</label>
      <input value={name} onChange={e=>setName(e.target.value)} placeholder="e.g. Amara Khumalo" style={{ width:"100%", background:"#f5f5f5", border:"0.5px solid rgba(0,0,0,0.18)", borderRadius:11, padding:"9px 12px", fontSize:13, color:"#111", outline:"none", marginBottom:12 }}/>

      <label style={{ fontSize:11, color:"#666", marginBottom:4 }}>Your city</label>
      <select value={city} onChange={e=>setCity(e.target.value)} style={{ width:"100%", background:"#f5f5f5", border:"0.5px solid rgba(0,0,0,0.18)", borderRadius:11, padding:"9px 12px", fontSize:13, color:"#111", outline:"none", marginBottom:16, appearance:"none" }}>
        {CITIES.map(c=><option key={c}>{c}</option>)}
      </select>

      <div style={{ fontSize:13, fontWeight:500, color:"#111", marginBottom:10 }}>How do you experience your city?</div>
      <div style={{ display:"flex", flexDirection:"column", gap:8, marginBottom:20 }}>
        {VIBES.map(o=>(
          <div key={o.id} onClick={()=>setVibe(o.id)} style={{ display:"flex", alignItems:"center", gap:10, padding:"11px 12px", borderRadius:13, border:`${vibe===o.id?"1.5px solid #7F77DD":"0.5px solid rgba(0,0,0,0.14)"}`, background:vibe===o.id?"#EEEDFE":"#fff", cursor:"pointer" }}>
            <div style={{ width:34, height:34, borderRadius:9, background:"#f5f5f5", display:"flex", alignItems:"center", justifyContent:"center", fontSize:17, flexShrink:0 }}>{o.emoji}</div>
            <div>
              <div style={{ fontSize:13, fontWeight:500, color:"#111" }}>{o.label}</div>
              <div style={{ fontSize:11, color:"#666" }}>{o.desc}</div>
            </div>
          </div>
        ))}
      </div>
      <button onClick={()=>{ if(name && vibe) onDone({name, city, vibe}); }} disabled={!name || !vibe} style={{ width:"100%", background:name&&vibe?"#7F77DD":"#ddd", color:name&&vibe?"#fff":"#999", border:"none", borderRadius:20, padding:13, fontSize:15, fontWeight:500, cursor:name&&vibe?"pointer":"default" }}>
        Find my pulse →
      </button>
    </div>
  );
}

// ── Create Event ───────────────────────────────────────────────────────────
export function CreateEventScreen({ onBack, onSubmit, city }) {
  const [f, setF] = useState({ title:"", cat:"concert", date:"", time:"", venue:"", price:"", desc:"", highlights:"" });
  const upd = (k,v) => setF(x=>({...x,[k]:v}));
  const CATS = ["concert","party","sports","food","outdoor","festival","wellness","culture"];
  const CAT_GRADS = { concert:"linear-gradient(135deg,#534AB7,#D4537E)", party:"linear-gradient(135deg,#D85A30,#BA7517)", sports:"linear-gradient(135deg,#1D9E75,#185FA5)", food:"linear-gradient(135deg,#D4537E,#D85A30)", outdoor:"linear-gradient(135deg,#EF9F27,#D85A30)", festival:"linear-gradient(135deg,#BA7517,#EF9F27)", wellness:"linear-gradient(135deg,#5DCAA5,#85B7EB)", culture:"linear-gradient(135deg,#378ADD,#534AB7)" };
  const submit = () => {
    if (!f.title || !f.venue) return;
    onSubmit({ ...f, id:"ev_"+Date.now(), city, grad:CAT_GRADS[f.cat]||CAT_GRADS.concert, color:"#7F77DD", priceLabel:f.price?"R"+f.price:"Free", price:parseInt(f.price)||0, crowd:"TBA", highlights:f.highlights.split(",").map(h=>h.trim()).filter(Boolean), vibes:["Exciting","Social","Memorable"], lineup:[], lat:Math.round(30+Math.random()*40), lng:Math.round(20+Math.random()*50), live:false, rating:null, ratingCount:0 });
  };

  return (
    <Screen>
      <div style={{ background:"#fff", padding:"12px 16px 10px", borderBottom:"0.5px solid rgba(0,0,0,0.08)", display:"flex", justifyContent:"space-between", alignItems:"center", flexShrink:0 }}>
        <button onClick={onBack} style={{ background:"none", border:"none", cursor:"pointer", fontSize:12, color:"#666" }}>← Back</button>
        <div style={{ fontSize:15, fontWeight:500, color:"#111" }}>Create event</div>
        <div style={{ width:40 }}/>
      </div>
      <ScrollArea style={{ padding:"13px 16px" }}>
        <div style={{ border:"0.5px dashed rgba(0,0,0,0.2)", borderRadius:11, padding:16, textAlign:"center", cursor:"pointer", background:"#f9f9f9", marginBottom:12 }}>
          <div style={{ fontSize:22 }}>📷</div>
          <div style={{ fontSize:12, color:"#666", marginTop:4 }}>Add event photo</div>
        </div>
        {[{k:"title",lbl:"Event name",ph:"e.g. Sunset Jazz at Signal Hill"},{k:"venue",lbl:"Venue",ph:"e.g. Signal Hill, Cape Town"},{k:"date",lbl:"Date",ph:"",type:"date"},{k:"time",lbl:"Time",ph:"",type:"time"},{k:"price",lbl:"Ticket price (leave blank = free)",ph:"e.g. 150"}].map(fi=>(
          <div key={fi.k} style={{ marginBottom:10 }}>
            <label style={{ fontSize:11, color:"#666", display:"block", marginBottom:4 }}>{fi.lbl}</label>
            <input type={fi.type||"text"} value={f[fi.k]} onChange={e=>upd(fi.k,e.target.value)} placeholder={fi.ph} style={{ width:"100%", background:"#f5f5f5", border:"0.5px solid rgba(0,0,0,0.14)", borderRadius:11, padding:"9px 12px", fontSize:13, color:"#111", outline:"none" }}/>
          </div>
        ))}
        <div style={{ marginBottom:10 }}>
          <label style={{ fontSize:11, color:"#666", display:"block", marginBottom:6 }}>Category</label>
          <div style={{ display:"flex", gap:6, flexWrap:"wrap" }}>
            {CATS.map(c=><button key={c} onClick={()=>upd("cat",c)} style={{ fontSize:11, padding:"5px 12px", borderRadius:20, border:`0.5px solid ${f.cat===c?"#7F77DD":"rgba(0,0,0,0.14)"}`, background:f.cat===c?"#7F77DD":"none", color:f.cat===c?"#fff":"#555", cursor:"pointer" }}>{c.charAt(0).toUpperCase()+c.slice(1)}</button>)}
          </div>
        </div>
        <div style={{ marginBottom:10 }}>
          <label style={{ fontSize:11, color:"#666", display:"block", marginBottom:4 }}>Description</label>
          <textarea value={f.desc} onChange={e=>upd("desc",e.target.value)} placeholder="What makes this event special?" style={{ width:"100%", background:"#f5f5f5", border:"0.5px solid rgba(0,0,0,0.14)", borderRadius:11, padding:"9px 12px", fontSize:13, color:"#111", outline:"none", resize:"none", height:72, fontFamily:"inherit" }}/>
        </div>
        <div style={{ marginBottom:14 }}>
          <label style={{ fontSize:11, color:"#666", display:"block", marginBottom:4 }}>Highlights (comma separated)</label>
          <input value={f.highlights} onChange={e=>upd("highlights",e.target.value)} placeholder="e.g. Live DJ, Open bar, City views" style={{ width:"100%", background:"#f5f5f5", border:"0.5px solid rgba(0,0,0,0.14)", borderRadius:11, padding:"9px 12px", fontSize:13, color:"#111", outline:"none" }}/>
        </div>
        {f.title && (
          <div style={{ background:"#EEEDFE", borderRadius:11, padding:"10px 12px", marginBottom:12 }}>
            <div style={{ fontSize:11, color:"#534AB7", marginBottom:2 }}>Preview</div>
            <div style={{ fontSize:13, fontWeight:500, color:"#111" }}>{f.title}</div>
            <div style={{ fontSize:11, color:"#666" }}>{f.venue||"Venue TBD"} · {f.price?"R"+f.price:"Free"}</div>
          </div>
        )}
        <button onClick={submit} disabled={!f.title||!f.venue} style={{ width:"100%", background:f.title&&f.venue?"#7F77DD":"#ddd", color:f.title&&f.venue?"#fff":"#999", border:"none", borderRadius:20, padding:12, fontSize:14, fontWeight:500, cursor:f.title&&f.venue?"pointer":"default", marginBottom:6 }}>
          Publish event on iPulse
        </button>
        <div style={{ textAlign:"center", fontSize:10, color:"#999" }}>Events are reviewed within 2 hours</div>
        <div style={{ height:10 }}/>
      </ScrollArea>
    </Screen>
  );
}

// ── Edit Profile ───────────────────────────────────────────────────────────
export function EditProfileScreen({ user, onBack, onSave }) {
  const [f, setF] = useState({ ...user });
  return (
    <Screen>
      <div style={{ background:"#fff", padding:"12px 16px 10px", borderBottom:"0.5px solid rgba(0,0,0,0.08)", display:"flex", justifyContent:"space-between", alignItems:"center", flexShrink:0 }}>
        <button onClick={onBack} style={{ background:"none", border:"none", cursor:"pointer", fontSize:12, color:"#666" }}>← Back</button>
        <div style={{ fontSize:15, fontWeight:500, color:"#111" }}>Edit profile</div>
        <div style={{ width:40 }}/>
      </div>
      <ScrollArea style={{ padding:"13px 16px" }}>
        {[{k:"name",lbl:"Name"},{k:"bio",lbl:"Bio",ph:"Something about you..."}].map(fi=>(
          <div key={fi.k} style={{ marginBottom:10 }}>
            <label style={{ fontSize:11, color:"#666", display:"block", marginBottom:4 }}>{fi.lbl}</label>
            <input value={f[fi.k]||""} onChange={e=>setF(x=>({...x,[fi.k]:e.target.value}))} placeholder={fi.ph} style={{ width:"100%", background:"#f5f5f5", border:"0.5px solid rgba(0,0,0,0.14)", borderRadius:11, padding:"9px 12px", fontSize:13, color:"#111", outline:"none" }}/>
          </div>
        ))}
        <div style={{ marginBottom:12 }}>
          <label style={{ fontSize:11, color:"#666", display:"block", marginBottom:4 }}>City</label>
          <select value={f.city||"Cape Town"} onChange={e=>setF(x=>({...x,city:e.target.value}))} style={{ width:"100%", background:"#f5f5f5", border:"0.5px solid rgba(0,0,0,0.14)", borderRadius:11, padding:"9px 12px", fontSize:13, color:"#111", outline:"none", appearance:"none" }}>
            {CITIES.map(c=><option key={c}>{c}</option>)}
          </select>
        </div>
        <div style={{ marginBottom:16 }}>
          <label style={{ fontSize:11, color:"#666", display:"block", marginBottom:6 }}>Vibe</label>
          {["introvert","extrovert","tourist","explorer"].map(v=>(
            <button key={v} onClick={()=>setF(x=>({...x,vibe:v}))} style={{ margin:"0 5px 5px 0", fontSize:12, padding:"5px 13px", borderRadius:20, border:`0.5px solid ${f.vibe===v?"#7F77DD":"rgba(0,0,0,0.14)"}`, background:f.vibe===v?"#7F77DD":"none", color:f.vibe===v?"#fff":"#555", cursor:"pointer" }}>
              {v.charAt(0).toUpperCase()+v.slice(1)}
            </button>
          ))}
        </div>
        <button onClick={()=>onSave(f)} style={{ width:"100%", background:"#7F77DD", color:"#fff", border:"none", borderRadius:20, padding:12, fontSize:14, fontWeight:500, cursor:"pointer" }}>Save changes</button>
        <div style={{ height:10 }}/>
      </ScrollArea>
    </Screen>
  );
}
